import React from 'react';
import '../../App.css';
import { Button } from '../Button';
import { useNavigate } from "react-router-dom";
import Navbar from '../Navbar';


export default function Blogs() {

  const navigate = useNavigate();

  function handleClick() {
    navigate(document.getElementById('blog_name').value);
  }

  return (
    <>
      <Navbar/>
      <div className='about-container'>
      <div>&nbsp;</div>
      <div>&nbsp;</div>
      <div className='about-section'>
      <div style={{textAlign: 'center'}}>I am not a great writer so most of my blogs are personal. I write blogs to keep track of my thoughts and to reflect on them later. I have not made my blogs public yet. Still deciding whether I should or not. Most of them are personal and not worth sharing anyways. However, if you know the blog key (thats only me LOL), you are in luck.</div>
      <div>&nbsp;</div>
      <div>&nbsp;</div>
      <div style={{textAlign: 'center'}}>
      <div>Enter the key of blog</div>
      <div>&nbsp;</div>
      <input style={{height:'36px', width:'180px'}} type="text" id="blog_name" name="blog_name"/>
      <div>&nbsp;</div>
       <Button
          className='btns'
          buttonStyle='btn--primary'
          buttonSize='btn--large'
          onClick={(e) => {
            e.preventDefault();
            handleClick()
            }}>
          View Blog
        </Button>
        </div>
      </div>
    </div>
    </>
    
  );
}
